// src/messaging/MessageSettings.jsx
// メッセージの設定（1対1の既読・ブロック中の人）【2026-10-16】
import React, { useCallback, useEffect, useState } from 'react';
import { msgApi } from './api';
import { dateOnly } from './util';
import { Modal } from './ui';

export default function MessageSettings({ isStudent, onClose, onChanged }) {
  const [settings, setSettings] = useState(null);
  const [blocks, setBlocks] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    const [s, b] = await Promise.all([msgApi.get('/settings'), msgApi.get('/blocks')]);
    if (s.success) setSettings(s.settings); else setErr(s.message || '読み込めませんでした');
    setBlocks(b.success ? b.blocks : []);
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggleRead = async () => {
    if (!settings) return;
    setBusy(true); setErr('');
    const r = await msgApi.put('/settings', { read_receipts: !settings.read_receipts });
    setBusy(false);
    if (!r.success) { setErr(r.message || '変えられませんでした'); return; }
    setSettings(r.settings);
  };

  const unblock = async (b) => {
    if (!window.confirm(`${b.user.name}さんのブロックを解除しますか？`)) return;
    const r = await msgApi.del(`/blocks/${b.user.id}`);
    if (!r.success) { setErr(r.message || '解除できませんでした'); return; }
    load();
    onChanged && onChanged();
  };

  return (
    <Modal title="メッセージの設定" onClose={onClose}>
      {err && <p className="msg-error">{err}</p>}
      {isStudent && (
        <section className="msg-settings-sec">
          <h4>1対1の既読</h4>
          <label className="msg-switch">
            <input type="checkbox" checked={!!(settings && settings.read_receipts)} disabled={!settings || busy} onChange={toggleRead} />
            <span>相手に「既読」を表示する</span>
          </label>
          <p className="msg-help">オフにすると、相手の既読も見えなくなります。先生とのやり取りやグループには、もともと既読は出ません。</p>
        </section>
      )}
      <section className="msg-settings-sec">
        <h4>ブロック中の人</h4>
        {blocks === null ? <p className="msg-help">読み込み中...</p>
          : blocks.length === 0 ? <p className="msg-help">ブロックしている人はいません。</p>
            : (
              <ul className="msg-member-list">
                {blocks.map(b => (
                  <li key={b.user.id}>
                    <div className="msg-member-row">
                      <span className="msg-member-name">{b.user.name}</span>
                      <span className="msg-note-meta">{dateOnly(b.created_at)}から</span>
                      <span className="msg-member-actions">
                        <button type="button" className="btn-link" onClick={() => unblock(b)}>解除</button>
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
        <p className="msg-help">ブロックしたことは相手に知らされません。</p>
      </section>
    </Modal>
  );
}
